<template>
  <div class="ui center aligned fluid container">
    <transition name="fade" mode="out-in">
      <h1
        class="ui center aligned header"
        :key="$store.state.game.currentRound"
      >
        {{ $store.getters.currentRound.name }}
      </h1>
    </transition>
    <scoreboard-horizontal></scoreboard-horizontal>
    <div class="ui hidden divider" v-if="isHost"></div>
    <div
      class="ui right labeled icon orange massive button"
      @click.once="startRound"
      id="start-round"
      :data-round-id="$store.state.game.currentRound"
      v-if="isHost"
    >
      <i class="play icon"></i> Start Ronde [ENTER]
    </div>
    <div class="ui hidden divider"></div>
    <div class="ui text container">
      <transition name="fade" mode="out-in">
        <div class="ui compact segment" :key="$store.state.game.currentRound">
          <h2 class="ui header">{{ roundDescription }}</h2>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScoreboardHorizontal from '@/components/elements/scoreboardHorizontal';
import { ROUNDS } from '@/config';
import sounds from '@/sounds';
import Mousetrap from 'mousetrap';
import { sendPage } from '@/utils/ga';

export default {
  name: 'round-intro',
  components: { ScoreboardHorizontal },
  computed: {
    ...mapGetters(['isHost']),
    roundDescription() {
      return ROUNDS[this.$store.state.game.currentRound].description;
    }
  },
  created() {
    this.addKeyboardShortcuts();
    this.trackPage();
  },
  updated() {
    this.trackPage();
  },
  methods: {
    startRound() {
      sounds.setup();
      this.$store.dispatch(
        `${ROUNDS[this.$store.state.game.currentRound].slug}/startRound`
      );
      this.$store.dispatch('syncGame');
    },
    addKeyboardShortcuts() {
      Mousetrap.bind('enter', () => {
        const startButton = document.querySelector('#start-round');
        if (startButton) startButton.click();
        return false;
      });
    },
    trackPage() {
      sendPage(`/${ROUNDS[this.$store.state.game.currentRound].slug}`);
    }
  }
};
</script>

<style scoped>
.ui.header {
  font-size: 4rem;
}
h2.ui.header {
  font-size: 1.6rem;
}
</style>
